<template>
  <v-dialog :model-value="modelValue" max-width="720px" persistent data-testid="year-dialog" @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title class="bg-primary text-white">
        <v-icon class="mr-2">{{ isEditMode ? 'mdi-calendar-edit' : 'mdi-calendar-plus' }}</v-icon>
        {{ isEditMode ? 'แก้ไขปีภาษี' : 'เพิ่มปีภาษี' }}
      </v-card-title>

      <v-card-text class="pt-4">
        <v-form ref="form" v-model="formValid">
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                data-testid="year-select"
                v-model="form.beYear"
                :items="yearOptions"
                label="ปี พ.ศ. *"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-calendar"
                :rules="[rules.required]"
                :readonly="isEditMode"
                @update:model-value="onYearChange"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                data-testid="year-taxYear-input"
                v-model="form.taxYear"
                label="Tax year code *"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-identifier"
                placeholder="TY2569"
                :rules="[rules.required]"
                :readonly="isEditMode"
              />
            </v-col>
          </v-row>

          <v-text-field
            data-testid="year-description-input"
            v-model="form.description"
            label="Description"
            variant="outlined"
            density="comfortable"
            prepend-inner-icon="mdi-text-box-outline"
            placeholder="Notes about this tax year"
          />

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                data-testid="year-startDate-input"
                v-model="form.effectiveStartDate"
                label="Effective start date"
                type="date"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-calendar-start"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                data-testid="year-endDate-input"
                v-model="form.effectiveEndDate"
                label="Effective end date"
                type="date"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-calendar-end"
              />
            </v-col>
          </v-row>

          <v-switch
            data-testid="year-active-switch"
            v-model="form.isActive"
            label="Active"
            color="success"
            inset
            hide-details
          />
        </v-form>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn data-testid="year-cancel-btn" variant="outlined" @click="close">
          <v-icon start>mdi-close</v-icon>
          Cancel
        </v-btn>
        <v-btn
          data-testid="year-create-btn"
          color="primary"
          variant="elevated"
          :disabled="!formValid"
          @click="submit"
        >
          <v-icon start>mdi-content-save</v-icon>
          {{ isEditMode ? 'Update' : 'Create' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TaxYearDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    yearOptions: { type: Array, default: () => [] },
    initialData: { type: Object, default: null },
  },
  emits: ['update:modelValue', 'submit'],
  data() {
    return {
      formValid: false,
      form: this.buildEmptyForm(),
      rules: {
        required: (v) => (v !== null && v !== undefined && String(v).trim() !== '') || 'Required',
      },
    };
  },
  computed: {
    isEditMode() {
      return Boolean(this.initialData && this.initialData.taxYear);
    },
  },
  watch: {
    modelValue(open) {
      if (open) this.resetForm();
    },
  },
  methods: {
    buildEmptyForm() {
      const beYear = new Date().getFullYear() + 543 + 1;
      const ceYear = beYear - 543;
      return {
        beYear,
        year: ceYear,
        taxYear: `TY${beYear}`,
        description: '',
        effectiveStartDate: `${ceYear}-01-01`,
        effectiveEndDate: `${ceYear}-12-31`,
        isActive: true,
      };
    },
    resetForm() {
      this.form = this.initialData ? { ...this.initialData } : this.buildEmptyForm();
      this.$nextTick(() => this.$refs.form?.resetValidation?.());
    },
    onYearChange(beYear) {
      const ceYear = Number(beYear) - 543;
      this.form.beYear = Number(beYear);
      this.form.year = ceYear;
      this.form.taxYear = `TY${beYear}`;
      this.form.effectiveStartDate = `${ceYear}-01-01`;
      this.form.effectiveEndDate = `${ceYear}-12-31`;
    },
    close() {
      this.$emit('update:modelValue', false);
    },
    async submit() {
      const result = await this.$refs.form?.validate?.();
      if (result && result.valid === false) return;
      this.$emit('submit', { ...this.form });
    },
  },
};
</script>
